export default class ChatConversationCreateRequestDTO {

    static toJson(userId, message, context){
        let json = {};
        json['user-id'] = userId;
        json['message'] = message;
        json['context'] = [];
        context.forEach(object => {
            json.context.push({
                'resource-type' : object.resourceType,
                'resource-id' : object.resourceId
            })
        });
        return json;
    }
}